<template>
<div class="social-media-main">
    <div class="icon">
        <a href="https://twitter.com/share?ref_src=twsrc%5Etfw" class="twitter-share-button" data-size="large" data-text="Check out Greenham Women Digital!" data-url="https://greenhamwomen.digital" data-hashtags="#GreenhamCommon #PeaceCamp"
            data-show-count="false">Tweet</a>
    </div>
    <iframe src="https://www.facebook.com/plugins/share_button.php?href=https%3A%2F%2Fgreenhamwomen.digital&layout=button&size=large&width=77&height=28&appId" width="77" height="28" style="border:none;overflow:hidden" scrolling="no"
        frameborder="0" allowTransparency="true" allow="encrypted-media"></iframe>
</div>
</template>

<script>
export default {
    name: "SocialMedia",
    data() {
        return {

        }
    },
}
</script>

<style scoped>
.social-media-main {
    z-index: 999;
    position: fixed;
    bottom: 0;
    right: .3em;
}

.icon {
    padding-right: .3em;
    display: inline;
}
</style>
